import { HelpCircle } from "lucide-react";
import StarRating from "./StarRating";

interface Props {
  nomor: number;
  pertanyaan: string;
  rating: number;
  onChange: (rating: number) => void;
}

const QuestionCard = ({ nomor, pertanyaan, rating, onChange }: Props) => {
  return (
    <div
      className="
        group
        relative
        overflow-hidden
        rounded-3xl
        border
        border-lime-100
        bg-white
        p-6
        shadow-[0_8px_30px_rgba(132,204,22,0.10)]
        transition-all
        duration-500
        hover:-translate-y-1
        hover:border-lime-300
        hover:shadow-[0_20px_60px_rgba(132,204,22,0.20)]
      ">
      {/* Glow */}
      <div className="absolute -right-16 -top-16 h-36 w-36 rounded-full bg-lime-200/30 blur-3xl transition-all duration-500 group-hover:bg-lime-300/40" />

      {/* Number */}
      <div className="mb-5 flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-lime-500 to-green-600 text-lg font-bold text-white shadow-lg">{nomor}</div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-lime-600">Pertanyaan</p>

          <h3 className="font-bold text-slate-800">Penilaian #{nomor}</h3>
        </div>
      </div>

      {/* Isi Pertanyaan */}
      <div className="flex gap-4">
        <HelpCircle size={22} className="mt-1 shrink-0 text-lime-600" />

        <p className="leading-8 text-slate-700">{pertanyaan}</p>
      </div>

      {/* Rating */}
      <div className="mt-8 rounded-2xl bg-lime-50 p-5">
        <div className="mb-3 flex items-center justify-between">
          <span className="text-sm font-medium text-slate-600">Berikan Penilaian</span>

          <span className="rounded-full bg-white px-3 py-1 text-sm font-bold text-lime-700 shadow">{rating || 0}/5</span>
        </div>

        <StarRating value={rating} onChange={onChange} size={34} />
      </div>
    </div>
  );
};

export default QuestionCard;
